// All of platform_ui, for an app that uses all of it. Another app imports only the tiers it needs (core, forms, ...)
// and registers them on its own Stimulus application. The pack's package.json lists the npm packages they import.
import { Application } from '@hotwired/stimulus'
import * as core from './core'
import * as forms from './forms'
import * as tomSelect from './forms/tom_select'
import * as flatpickr from './forms/flatpickr'
import * as autonumeric from './forms/autonumeric'
import * as overlays from './overlays'
import * as uploads from './uploads'
import * as workflow from './workflow'

const application = Application.start()
application.debug = false
window.Stimulus = application

for (const tier of [core, forms, tomSelect, flatpickr, autonumeric, overlays, uploads, workflow]) {
  tier.register(application)
}
